import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { Empty, Flex, Radio, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Text from 'shared/components/typography/Text'
import Collapse from '../../Collapse'
import s from './s.module.css'
import { lang } from './lang'
import { OptionType } from '@/pages/Donation/types'
import { PaymentType } from '@/pages/Donation/api/streamer/types'

type Props<T> = {
  title: ReactNode
  isSelected: boolean
  visibleOptions: T[]
  renderOption: (option: T) => ReactNode
  paymentType: PaymentType
  isOptionsLoading?: boolean
  loadingText?: ReactNode
  rightContent?: ReactNode
}

export default function TypeBlock<T extends OptionType>({
  isSelected,
  visibleOptions,
  title,
  rightContent,
  renderOption,
  paymentType,
  isOptionsLoading,
  loadingText,
}: Props<T>) {
  const isEmptyOptions = visibleOptions.length === 0 && !isOptionsLoading

  let optionsContent = null

  if (isOptionsLoading) {
    optionsContent = (
      <Flex justify="center" align="center" vertical className={s.loadingWrap}>
        <Spin indicator={<LoadingOutlined style={{ color: 'var(--accent-light)' }} />} />
        {loadingText ? (
          <Text fontType="body" fontSize={14}>
            {loadingText}
          </Text>
        ) : null}
      </Flex>
    )
  } else if (isEmptyOptions) {
    optionsContent = (
      <Empty
        description={
          <Text fontType="body" fontSize={14}>
            <FormattedMessage {...lang.noOptions} />
          </Text>
        }
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    )
  } else {
    optionsContent = (
      <Flex vertical gap={12}>
        {visibleOptions.map((option, key) => (
          <div key={key}>{renderOption(option)}</div>
        ))}
      </Flex>
    )
  }

  return (
    <Collapse
      isOpen={isSelected}
      header={
        <Radio value={paymentType} className={s.radio}>
          <Flex justify="space-between" align="center">
            <Text fontSize={14} fontType="title" type="primary">
              {title}
            </Text>
          </Flex>
        </Radio>
      }
      right={rightContent}
    >
      {optionsContent}
    </Collapse>
  )
}
